import React from 'react';
import { Section } from '../../../components/Section';
import { IconWrap } from '../../../components/IconWrap';
import useTheme from '../../../hooks/useTheme';
import { megaGreenData } from '../../../data/data';
import { CiCalendar } from 'react-icons/ci';
import { BiFile, BiShield } from 'react-icons/bi';

interface ProofStripProps {
    index?: number;
}

export const ProofStrip: React.FC<ProofStripProps> = ({ index }) => {
    const { theme, breakpoint } = useTheme();
    const proofItems = megaGreenData.home.proofStrip;

    const iconMap: Record<string, React.ReactNode> = {
        calendar: <CiCalendar />,
        shield: <BiShield />,
        document: <BiFile />,
    };

    return (
        <Section
            index={index}
            style={{
                paddingTop: '48px',
                paddingBottom: '48px',
            }}
        >
            <div
                style={{
                    display: 'grid',
                    gridTemplateColumns: breakpoint.xs || breakpoint.sm ? '1fr' : 'repeat(3, 1fr)',
                    gap: '32px',
                    maxWidth: '900px',
                    margin: '0 auto',
                }}
            >
                {proofItems.map((item, idx) => (
                    <div
                        key={idx}
                        style={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            textAlign: 'center',
                            gap: '12px',
                        }}
                    >
                        <IconWrap
                            icon={iconMap[item.icon] || <BiFile />}
                            size={40}
                            color="primary"
                            withBackground={true}
                        />
                        <div
                            style={{
                                fontSize: '16px',
                                fontWeight: 600,
                                color: theme.text.primary,
                            }}
                        >
                            {item.label}
                        </div>
                    </div>
                ))}
            </div>
        </Section>
    );
};

